<script>
import moment from 'moment'
export default {
  name: 'orders-info-card',
  data: () => ({
    status: {}
  }),
  mounted () {
    this.onRefresh()
  },
  methods: {
    async onRefresh () {
      this.status = {
        open: total_open,
        ready: total_ready,
        processing: total_processing,
        backorder: total_backorder,
        rejected: total_rejected
      }

      let total_open = await this.$HASURA.webForms.countWhere({
        draft: { _eq: false },
        status: { _ilike: 'open' }
      })

      let total_ready = await this.$HASURA.webForms.countWhere({
        draft: { _eq: false },
        status: { _ilike: 'ready' }
      })

      let total_processing = await this.$HASURA.webForms.countWhere({
        draft: { _eq: false },
        status: { _ilike: 'processing' }
      })

      let total_backorder = await this.$HASURA.webForms.countWhere({
        draft: { _eq: false },
        status: { _ilike: 'backorder' }
      })

      let total_rejected = await this.$HASURA.webForms.countWhere({
        draft: { _eq: false },
        status: { _ilike: 'rejected' }
      })

      this.status = {
        open: total_open,
        ready: total_ready,
        processing: total_processing,
        backorder: total_backorder,
        rejected: total_rejected
      }
    }
  }
}
</script>
<template>
  <b-card no-body>
    <b-card-body>
      <div class="clearfix">
        <div class="float-right">
          <b-btn variant="link" v-on:click="onRefresh"
            ><i class="fas fa-sync"></i
          ></b-btn>
        </div>
        <h4 class="card-title">Order Summary</h4>
        <p class="card-title-desc">By Status</p>
      </div>
      <div class="d-flex flex-column align-items-center flex-wrap">
        <router-link
          :to="{ name: 'my-orders', query: { status: 'open' } }"
          class="w-100"
        >
          <g-stat-card
            :title="$t('dashboard.stats.open_orders')"
            icon="bx bx-folder-open"
            :value="status.open"
        /></router-link>
        <router-link
          :to="{ name: 'my-orders', query: { status: 'processing' } }"
          class="w-100"
        >
          <g-stat-card
            :title="$t('dashboard.stats.processing_orders')"
            icon="bx bx-cog bx-spin"
            :value="status.processing"
            variant="info"
        /></router-link>
        <router-link
          :to="{ name: 'my-orders', query: { status: 'ready' } }"
          class="w-100"
        >
          <g-stat-card
            :title="$t('dashboard.stats.ready_orders')"
            icon="bx bx-check"
            :value="status.ready"
            variant="success"
        /></router-link>
        <router-link
          :to="{ name: 'my-orders', query: { status: 'backorder' } }"
          class="w-100"
        >
          <g-stat-card
            :title="$t('dashboard.stats.back_orders')"
            icon="bx bx-time-five"
            :value="status.backorder"
            variant="warning"
        /></router-link>
        <router-link
          :to="{ name: 'my-orders', query: { status: 'rejected' } }"
          class="w-100"
        >
          <g-stat-card
            :title="$t('dashboard.stats.rejected_orders')"
            icon="bx bx-error-alt bx-tada"
            :value="status.rejected"
            variant="danger"
        /></router-link>
      </div>
    </b-card-body>
  </b-card>
</template>
